import { brand } from '@/styles/shared';
interface BrainIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: string;
}

const BrainIcon: React.FC<BrainIconProps> = ({
  width = 22,
  height = 22,
  stroke = brand.purpleAccent,
  strokeWidth = '1.99954',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9985 4.00815C10.9997 3.60827 10.9209 3.2122 10.7668 2.84322C10.6126 2.47424 10.3863 2.1398 10.101 1.85959C9.81572 1.57937 9.47729 1.35903 9.10561 1.21152C8.73393 1.06401 8.33651 0.992318 7.93672 1.00065C7.53692 1.00898 7.14283 1.09718 6.77762 1.26005C6.41242 1.42291 6.08346 1.65717 5.81011 1.94903C5.53676 2.24089 5.32453 2.58446 5.1859 2.95954C5.04728 3.33463 4.98505 3.73364 5.00289 4.13312C4.41523 4.28423 3.86965 4.56707 3.40749 4.96025C2.94532 5.35342 2.57869 5.8466 2.33535 6.40245C2.09201 6.9583 1.97834 7.56223 2.00297 8.16851C2.02759 8.77479 2.18985 9.36752 2.47747 9.90181C1.97177 10.3126 1.5741 10.8408 1.31907 11.4404C1.06404 12.04 0.959374 12.6928 1.01417 13.342C1.06896 13.9913 1.28156 14.6173 1.63347 15.1656C1.98538 15.714 2.46594 16.168 3.03334 16.4883C2.96327 17.0304 3.00509 17.5811 3.1562 18.1065C3.30731 18.6318 3.56452 19.1205 3.91193 19.5426C4.25934 19.9646 4.68957 20.3109 5.17607 20.5601C5.66257 20.8094 6.195 20.9562 6.74047 20.9916C7.28595 21.027 7.83289 20.9502 8.34751 20.7659C8.86214 20.5817 9.33353 20.2939 9.73257 19.9203C10.1316 19.5467 10.4498 19.0953 10.6676 18.5939C10.8853 18.0925 10.9979 17.5518 10.9985 17.0052V4.00815Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9985 4.00815C10.9974 3.60827 11.0762 3.2122 11.2303 2.84322C11.3844 2.47424 11.6108 2.1398 11.8961 1.85959C12.1814 1.57937 12.5198 1.35903 12.8915 1.21152C13.2631 1.06401 13.6606 0.992318 14.0604 1.00065C14.4601 1.00898 14.8542 1.09718 15.2194 1.26005C15.5847 1.42291 15.9136 1.65717 16.187 1.94903C16.4603 2.24089 16.6725 2.58446 16.8112 2.95954C16.9498 3.33463 17.012 3.73364 16.9942 4.13312C17.5818 4.28423 18.1274 4.56707 18.5896 4.96025C19.0517 5.35342 19.4184 5.8466 19.6617 6.40245C19.9051 6.9583 20.0187 7.56223 19.9941 8.16851C19.9695 8.77479 19.8072 9.36752 19.5196 9.90181C20.0253 10.3126 20.423 10.8408 20.678 11.4404C20.933 12.04 21.0377 12.6928 20.9829 13.342C20.9281 13.9913 20.7155 14.6173 20.3636 15.1656C20.0117 15.714 19.5311 16.168 18.9637 16.4883C19.0338 17.0304 18.992 17.5811 18.8409 18.1065C18.6898 18.6318 18.4326 19.1205 18.0851 19.5426C17.7377 19.9646 17.3075 20.3109 16.821 20.5601C16.3345 20.8094 15.8021 20.9562 15.2566 20.9916C14.7111 21.027 14.1642 20.9502 13.6496 20.7659C13.1349 20.5817 12.6635 20.2939 12.2645 19.9203C11.8655 19.5467 11.5472 19.0953 11.3295 18.5939C11.1118 18.0925 10.9991 17.5518 10.9985 17.0052V4.00815Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9982 12.0063C13.1588 11.711 12.4258 11.1735 11.892 10.4617C11.3581 9.74985 11.0473 8.8957 10.9988 8.00723C10.9504 8.8957 10.6396 9.74985 10.1057 10.4617C9.57184 11.1735 8.83888 11.711 7.99952 12.0063M16.5966 5.5078C16.8385 5.08848 16.9754 4.61683 16.9955 4.13312M5.00321 4.13312C5.02298 4.61674 5.1595 5.08839 5.40112 5.5078M2.47778 9.9028C2.66068 9.75384 2.8564 9.62135 3.06265 9.50689M18.935 9.50689C19.1413 9.62135 19.337 9.75384 19.5199 9.9028M5.00021 17.0052C4.31119 17.0055 3.63379 16.8278 3.03366 16.4893M18.964 16.4893C18.3639 16.8278 17.6865 17.0055 16.9975 17.0052"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BrainIcon;
